<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_createActionAllowed"
            :title="'Přidat šablonu' | translate"
            route-name="messageTemplateNew"
        ></add-button>
        <h1 v-translate>Šablony oznámení</h1>
      </div>
      <div class="inner_white">
        <div class="filter search_only">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>

        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="message-template-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"/>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      :extra-style="title.style"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <message-template-row v-for="entity in entities"
                                      :entity="entity"
                                      :key="entity.id"
                                      :selected-entities="selectedEntities"
                                      @input="select"
                                      @updateTemplate="updateEntity"
                                      @deleteTemplate="deleteEntity"
                                      @useTemplate="useTemplate"
                ></message-template-row>
              <tr v-if="entities.length === 0">
                   <td colspan="8">{{ $gettext('Nebyly nalezeny žádné šablony oznámení.') }}</td>
              </tr>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              table-id="message-template-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="executeMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"
import MessageTemplateRow from "./MessageTemplateRow"
import messageTemplates from "./mixins/messageTemplates"

export default {
  name: "MessageTemplateList",
  components: {
    MessageTemplateRow,
  },
  mixins: [listActions, messageTemplates],
  data: function () {
    return {
      moduleName: 'messageTemplates',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      },
    }
  },
  created(MessageTemplateService) {
    this.entityService = MessageTemplateService
    this.createdInit()
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Poslední editace'), column: 'sDateUpdated'},
        {key: 3, name: this.$gettext('Upravil'), column: 'sUserUpdated'},
        {key: 4, name: this.$gettext('Počet použití šablony'), column: 'sNumberOfUses', style: {minWidth: '170px'}},
        {key: 5, name: this.$gettext('Globální oznámení'), column: 'sIdOperator'},
        {key: 6, name: this.$gettext('Typ oznámení'), column: 'sType'}
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      headers.id_operator.callback = entity =>{ return entity.global ? this.$gettext('Ano'): this.$gettext('Ne')};
      headers.type.callback = () => { return this.messageTemplateTypeOptions.find(o => o.value === this.entity.type).text};

      return headers;
    },
  },
  methods: {
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.deleteEntity(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
    },
    useTemplate(id) {
      this.$router.push({name: "messageNewFromTemplate", params: {id_template: id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/MessageTemplateList.vue